import { useSelector } from "react-redux";
import DashboardPrincipal from "./principal/DashboardPrincipal.js";
import DashboardTeacher from "./teacher/DashboardTeacher.js";
import DashboardStudent from "./student/DashboardStudent.js";
import DashboardOnboarding from "./onboarding/DashboardOnboarding.js";
import DashboardBilling from "./billing/DashboardBilling.js";
import DashboardTransport from "./transport/DashboardTransport.js";
import DashboardInventory from "./inventory/DashboardInventory.js";
import DashboardParent from "./parent/DashboardParent.js";
import DashboardIT from "./IT/DashboardIT.js";
import DashboardIT2 from "./IT2/DashboardIT2.js";

import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";

function Dashboard() {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <DashboardPrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <DashboardTeacher />;
    }
    if (state.auth.user.is_student) {
      return <DashboardStudent />;
    }
    if (state.auth.user.is_onboarding) {
      return <DashboardOnboarding />;
    }
    if (state.auth.user.is_billing) {
      return <DashboardBilling />;
    }
    if (state.auth.user.is_transport) {
      return <DashboardTransport />;
    }
    if (state.auth.user.is_inventory) {
      return <DashboardInventory />;
    }
    if (state.auth.user.is_attendance) {
      return <DashboardIT />;
    }
    if (state.auth.user.is_attendance2) {
      return <DashboardIT2 />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <DashboardParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
}

export default Dashboard;
